<template>
  <div class="page-container">
    <the-header></the-header>
    <base-breadcrumb></base-breadcrumb>
    <div role="main">
      <div class="page-title">
        <h1 role="heading" aria-level="1" tabindex="-1">{{ headerName() }}</h1>
      </div>
      <div class="content-container">
        <div class="wd-100">
          <div class="left-content-container">
            <router-view :tabName="tabName()"></router-view>
          </div>
        </div>
        <the-live-chat></the-live-chat>
        <div class="wd-10">
          <base-information :showInformation="true" :showResources="false"></base-information>
        </div>
      </div>
      <div class="information-btn desktop" v-if="!showInfo">
            <span @click="toggleInfoPopup()">Information</span>
      </div>
      <Teleport to="body">
        <div class="information-pop-up" v-if="showInfo">
          <button
            type="button"
            class="btn-close close"
            aria-label="Close information popup"
            @click="toggleInfoPopup()"
            ></button>
          <base-information :showInformation="true" :showResources="false"></base-information>
        </div>
      </Teleport>
    </div>  
    <div>
      <the-footer></the-footer>
    </div>
  </div>
</template>
<script>
  import {useRoute} from 'vue-router';
  import {BaseInformation, BaseBreadcrumb} from '@microchip/common-vue-components';
  import {TheHeader, TheFooter} from 'vue3-header-footer';
  import {ref} from 'vue';
  import { TheLiveChat } from "vue3-live-chat";

  export default {
    name: "App",
    components: {
      TheHeader,
      TheFooter,
      BaseInformation,
      BaseBreadcrumb,
      TheLiveChat
    },
    mounted() {
      window.addEventListener( "pageshow", function ( event ) {
        var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
        if ( historyTraversal ) {
          window.location.reload();
        }
      });
    },
    setup() {
      let showInfo = ref(false);
      const route = useRoute();

      function tabName() {
        return route.meta.tabName;
      }

      function headerName() {
        return route.meta.headerName;
      }

      function breadcrumb() {
        return route.meta.breadcrumb;
      }

      function toggleInfoPopup() {
        showInfo.value = !showInfo.value;
      }

      return {
        showInfo,
        toggleInfoPopup,
        tabName,
        headerName,
        breadcrumb,
      };
    }
  };
</script>

<style lang="scss">
@import 'bootstrap/dist/css/bootstrap.min.css';
@import "@microchip/common-vue-components/dist/commonvuecomponents.css";

  html, body {
    margin: 0px;
  }
  body {
    padding-top: 0px !important;
  }
  .page-title {
    background-color: var(--heading-bg-color);
    padding: 10px 0px;
    margin: 25px 0px 0px 0px;
  }
  .page-title h1 {
    padding-top: 0px;
    padding-bottom: 0px;
    color: var(--secondary-text-color);
    font-weight: 700;
    max-width: 1180px;
    margin-left: auto;
    margin-right: auto;
    white-space: nowrap;
    margin-bottom: 0px;
  }
  @media only screen and (max-width: 599px) {
    .page-title h1 {
      max-width: 90%;
    }
    .full-width {
      width: 100%;
    }
  }
  @media only screen and (min-width: 600px) and (max-width: 1199px) {
    .page-title h1 {
      max-width: 95%;
    }
  }
  .required {
    color: var(--form-field-error-bg-color);
    vertical-align: middle;
    font-size: 16px;
    margin-left: 5px;
    font-weight: 700;
  }
  .margin-top-45 {
    margin-top: 45px;
  }
  .margin-top-30 {
    margin-top: 30px;
  }
  .margin-top-20 {
    margin-top: 20px;
  }
  .margin-top-15 {
    margin-top: 15px;
  }
  .margin-bottom-5 {
    margin-bottom: 5px;
  }
  .margin-bottom-20 {
    margin-bottom: 20px;
  }
  .margin-left-10 {
    margin-left: 10px;
  }
  .text {
    color: var(--primary-text-color);
    font-size: 15px;
    font-family: Open Sans;
  }
  .wd-95 {
    width: 95%;
  }
  .text-area {
    resize: none;
    font-size: 16px;
    width: 100%;
  }
  .buttons-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .individual-label {
    background-color: var(--form-field-bg-color);
    color: var(--secondary-text-color);
    padding: 5px 10px 5px 10px;
    border-top-left-radius: 5px;
    min-width: 150px;
    font-size: 16px;
    font-family: Open Sans;
  }
  @media only screen and (max-width: 1199px) {
    html, body {
      margin: 0px;
    }
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
  }
  @media only screen and (max-width:767px) {
    .page-title h1 {
      font-size: 1.2rem;
    }
    .wd-100 {
      padding: 0px;
    }
    .left-content-container {
      display: flex;
      flex-direction: column;
      padding: 0px;
      max-width: 95%;
      margin-right: auto;
      margin-left: auto;
    }
    .two-column-form-container {
      display: flex;
      flex-direction: column;
    }
    .usb-form-container {
      margin-top: 10px;
    }
  }
  @media only screen and (min-width:768px) {
    .page-container {
      height: 100vh;
    }
    .page-title h1 {
      font-size: 1.2rem;
    }
    .left-content-container {
      display: flex;
      flex-direction: column;
      padding: 10px 0px;
    }
    .two-column-form-container {
      display: flex;
      flex-direction: row;
    }
    .wd-50 {
      flex: 1 1 50%;
      margin-right: 5%;
    }
    .usb-form-container {
      margin-top: 45px;
    }
    .wd-45 {
      flex: 1 1 45%;
    }
  }
  @media only screen and (max-width: 1199px) {
    .content-container {
      display: flex;
      flex-direction: column;
      padding: 5px 0px;
      max-width: 95%;
      margin-right: auto;
      margin-left: auto;
    }
  }
  @media only screen and (min-width: 1200px) {
    .wd-100 {
      flex: 1 1 100%;
      padding: 0px;
    }
    .wd-10 {
      display: none;
    }
    .content-container {
      display: flex;
      flex-direction: row;
      padding: 0px;
      max-width: 1180px;
      margin-right: auto;
      margin-left: auto;
    }
    .desktop {
      display: inline-block;
    }
    .mobile {
      display: none;
    }
  }
  .dropdown-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: var(--disabled-link-color);
    z-index: 9;
  }
  .block {
    display: block;
  }
  .information-btn {
    position: fixed;
    width: 120px;
    height: auto;
    right: -65px;
    top: 400px;
    opacity: 0.96;
    background-color: var(--button-bg-color);
    border-radius: 3px 0 0 3px;
    white-space: nowrap;
    transform-origin: 0% 0%;
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    transform: rotate(-90deg) translateX(50%);
    cursor: pointer;
  }
  .information-btn span {
    padding: 1rem;
    display: inline-block;
    color: var(--secondary-text-color);
  }
  .close {
    position: absolute;
    right: 5px;
    top: 5px;
  }
  .information-pop-up {
    width: 400px;
    position: fixed;
    z-index: 1;
    height: auto;
    top: 250px;
    right: 0;
    background-color: var(--information-bg-color);
    overflow-x: hidden;
    overflow-wrap: anywhere;
    word-break: break-word;
    animation: mymove 1s;
  }
  @keyframes mymove {
    from {right: -300px;}
    to {right: 0px;}
  }
  #usb-license-agreement.modal, #usb-success-modal.modal {
    padding: 0px;
    margin: 0px;
    top: 5% !important;
    left: 25% !important;
    --bs-modal-margin: 0rem;
    @media (max-width: 599px) {
      left: 2% !important;
      top: 2% !important;
      right: 2% !important;
    }
  }
  #usb-license-agreement.modal {
    max-width: 55% !important;
    height: 85% !important;
    @media (max-width: 599px) {
      height: 96% !important;
      max-width: 96% !important;
    }
  }
  #usb-success-modal.modal {
    max-width: 40% !important;
    height: auto !important;
    @media (max-width: 599px) {
      max-width: 96% !important;
      height: auto !important;
      top: 15% !important;
    }
    @media (min-width: 600px) and (max-width: 1023px) {
      height: auto !important;
      top: 15% !important;
      max-width: 50% !important;
    }
  }
  .blocker {
    z-index: 1055;
    background: transparent;
  }
  .modal-dialog {
    margin: 0 !important;
  }
  .modal a.close-modal {
    display: none;
  }
  #iseled-la-link {
    cursor: not-allowed;
    position: static;
  }
  .accordion-icon {
    width: 25px;
    height: 25px;
    padding-top: 0px;
    padding-left: 6px;
  }
</style>
